import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Box, Menu } from '@mui/material';
import React, { FC, useMemo, useState } from 'react';
import { usePatientProfile } from '../../../../../../hooks/use-patient-profile';
import { CircularProgress } from '../../../../../shared/audio-player/styles';
import { usePatientProfileWidget } from '../../hooks/use-patient-profile-widget';
import { RouteConfig } from '../../navigation/route-config';
import { useMainMenuConfig } from '../../navigation/use-main-menu-config';
import { HorizontalSeparator } from '../../patient-profile-widget.styles';
import { QuickNavMenuItem, QuickNavMenuTitle, QuickNavMenuWrapper } from './quick-nav-menu.styles';

export interface QuickNavMenuProps {
  loading?: boolean;
}

export const QuickNavMenu: FC<QuickNavMenuProps> = (props) => {
  const { loading } = props;
  const { contactDetails } = usePatientProfile();
  const { goTo, route, breadcrumbExtensions } = usePatientProfileWidget();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const routeConfig = useMemo(() => RouteConfig.find((config) => config.path === route), [route]);
  const mainMenuConfig = useMainMenuConfig();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (contactDetails) setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <QuickNavMenuWrapper>
        <QuickNavMenuTitle onClick={handleClick}>
          <MenuOpenIcon sx={{ marginRight: '10px' }} />
          {routeConfig?.name}
        </QuickNavMenuTitle>
        {loading && <CircularProgress sx={{ marginLeft: '5px', color: 'rgba(6, 117, 221, 1)' }} />}
        <Box sx={{ margin: 'auto' }}>{breadcrumbExtensions?.placeholers?.left?.component}</Box>
        {breadcrumbExtensions?.placeholers?.right?.component}
      </QuickNavMenuWrapper>
      <HorizontalSeparator />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          sx: { backgroundColor: 'white' },
          onMouseLeave: handleClose
        }}
      >
        {mainMenuConfig.map((item, index) => (
          <QuickNavMenuItem key={index} onClick={() => goTo(item.path)}>
            {item.title}
            {item.icon ? <Box sx={{ marginLeft: '8px' }}>{item.icon}</Box> : null}
          </QuickNavMenuItem>
        ))}
      </Menu>
    </Box>
  );
};
